
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCapacitor02 as ObiCapacitor02Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-capacitor-02.js';
 
 
 

 
 export const ObiCapacitor02 = createComponent({
   react: React,
   tagName: 'obi-capacitor-02',
   elementClass: ObiCapacitor02Element,
   events: {
     
   }
  });
 
 